@if (navCtx.hasContext()) {
  <div class="context-indicator" [class.context-indicator--phone-only]="navCtx.phoneOnly()">
    <!-- Vertical separator line (hidden on a phone, where every pixel of the bar counts) -->
    <div class="context-indicator__divider"></div>

    @if (navCtx.versus()) {
      <!-- Match: the two crests, and the score once it is played (CC's phone audit, 04/10/2026:
           the score was only in the Overview hero, so Videos/Stats/Events lost it). -->
      <a [routerLink]="navCtx.entityLink()"
         class="context-indicator__content context-indicator__content--clickable context-indicator__versus"
         [attr.aria-label]="versusLabel()">
        @if (navCtx.entityFlagUrl()) {
          <img [src]="navCtx.entityFlagUrl()" alt="" class="context-indicator__image">
        }
        @if (navCtx.versusScore(); as score) {
          <span class="context-indicator__score">{{ score }}</span>
        } @else {
          <span class="context-indicator__vs">vs</span>
        }
        @if (navCtx.entityFlagUrl2()) {
          <img [src]="navCtx.entityFlagUrl2()" alt="" class="context-indicator__image">
        }
      </a>
    } @else if (navCtx.entityLabel()) {
      <div class="context-indicator__row">
        @if (navCtx.entityLink()) {
          <a [routerLink]="navCtx.entityLink()" class="context-indicator__content context-indicator__content--clickable">
            <ng-container *ngTemplateOutlet="identity" />
          </a>
        } @else {
          <div class="context-indicator__content">
            <ng-container *ngTemplateOutlet="identity" />
          </div>
        }
      </div>
    }
  </div>
}

<ng-template #identity>
  <div class="context-indicator__images">
    @if (navCtx.entityFlagUrl()) {
      <img [src]="navCtx.entityFlagUrl()" alt="" class="context-indicator__image">
    }
    @if (navCtx.entityFlagUrl2()) {
      <img [src]="navCtx.entityFlagUrl2()" alt="" class="context-indicator__image context-indicator__image--secondary">
    }
  </div>
  <div class="context-indicator__text">
    <span class="context-indicator__label">{{ navCtx.entityLabel() }}</span>
    @if (navCtx.entityVideoOnly()) { <app-video-only-badge /> }
    <!-- Season pages keep the name on its own: the season picker lives on the breadcrumb row on
         desktop and at the end of the tab row on a phone (CC, 04/10/2026). -->
    @if (!navCtx.season() && navCtx.entitySubLabel()) {
      <span class="context-indicator__sublabel">{{ navCtx.entitySubLabel() }}</span>
    }
  </div>
</ng-template>
